import AlignCenter from "../../icons/AlignCenter";
import AlignRight from "../../icons/AlignRight";
import AlignLeft from "../../icons/AlignLeft";
import CornerMedium from "../../icons/CornerMedium";
import CornerSmall from "../../icons/CornerSmall";
import CornerLarge from "../../icons/CornerLarge";
import { STEPS_FORMAT_TYPES } from "./defaults";

export const ALIGNMENT_OPTIONS = [
  { icon: AlignLeft, value: "left" },
  { icon: AlignCenter, value: "center" },
  { icon: AlignRight, value: "right" },
];

export const BOOLEAN_OPTIONS = [
  { label: "Yes", i18n: "yes", value: true },
  { label: "No", i18n: "no", value: false },
];

export const STEPS_FORMAT_OPTIONS = [
  { label: "01, 02, 03...", value: STEPS_FORMAT_TYPES.PADDED_NUMERIC },
  { label: "1, 2, 3...", value: STEPS_FORMAT_TYPES.PLAIN_NUMERIC },
  { label: "A, B, C...", value: STEPS_FORMAT_TYPES.ALPHABETIC },
];

export const PREFIX_OPTIONS = [
  { label: "Day", value: "day" },
  { label: "Step", value: "step" },
  { label: "Month", value: "month" },
  { label: "Quarter", value: "quarter" },
  { label: "Sprint", value: "sprint" },
  { label: "Year", value: "year" },
  { label: "Custom prefix", value: "custom" },
];

export const CORNERS_OPTIONS = [
  { icon: CornerSmall, value: 1 },
  { icon: CornerMedium, value: 8 },
  { icon: CornerLarge, value: 20 },
];
